<template>
  <div
    v-editable="blok"
    class="container-fluid"
    :class="styleClasses"
    :style="styleFromProps">
    <div class="row">
      <component
        :key="blok._uid"
        v-for="blok in blok.columns"
        :blok="blok"
        :publishedAt="publishedAt"
        :is="blok.component">
      </component>
    </div>
  </div>
</template>

<script>
export default {
  props: ['blok', 'publishedAt'],
  computed: {
    styleFromProps() {
      const bg = this.blok.background
      return bg ? `background:${bg};` : ''
    },
    styleClasses() {
      return this.blok.equal ? 'equal' : ''
    },
  },
}
</script>

<style scoped>
.equal .row {
  display: flex;
}
.container-fluid {
  margin-top: 15px;
  margin-bottom: 15px;
}
</style>
